"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var index_1 = require("../../_shared/components/layout/index");
var constants_1 = require("../../../constants");
require("./Activities.scss");
var moment = require("moment");
var utils_1 = require("../utils");
var Timeline_1 = require("../../_shared/components/timeline/Timeline");
var Activities = /** @class */ (function (_super) {
    __extends(Activities, _super);
    function Activities(newProps) {
        var _this = _super.call(this, newProps) || this;
        _this.timeZone = constants_1.DEFAULT_TIMEZONE;
        return _this;
    }
    Activities.prototype.parseTime = function (isTimeRange, startTime, endTime) {
        var _this = this;
        var time2String = function (time) {
            return moment(time).tz(_this.timeZone).format('HH:mm');
        };
        return isTimeRange ? "".concat(time2String(startTime), "-").concat(time2String(endTime)) :
            time2String(startTime);
    };
    Activities.prototype.getProjectName = function (projectId) {
        var projects = this.props.projects;
        var project = _.find(projects, function (project) { return project._id === projectId; });
        return project && project.number + ' ' + _.get(project, 'addresses[0].address.city');
    };
    Activities.prototype.parseActivity = function (activity) {
        /***
         * Depends on Activity type converts received data to Activity component structure
         ***/
        var _a = __assign({}, utils_1.ACTIVITY_MAPPER[activity.type]), _b = _a.icon, icon = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.projectName, projectName = _d === void 0 ? '' : _d, _e = _a.isTimeRange, isTimeRange = _e === void 0 ? true : _e, _f = _a.hasLine, hasLine = _f === void 0 ? true : _f;
        var time = this.parseTime(isTimeRange, activity.start_time, activity.end_time);
        var project = projectName || this.getProjectName(activity.project);
        var lineClass = hasLine ? 'with-line' : '';
        return { icon: icon, time: time, lineClass: lineClass, label: label, project: project, pathColor: (activity === null || activity === void 0 ? void 0 : activity.color) || '' };
    };
    Activities.prototype.render = function () {
        var _this = this;
        var activities = _.map(this.props.activities, function (activity, index) {
            var _a = _this.parseActivity(activity), icon = _a.icon, lineClass = _a.lineClass, time = _a.time, label = _a.label, project = _a.project, pathColor = _a.pathColor;
            return React.createElement(Timeline_1.default, { type: "project", index: index, title: project, time: time, icon: icon, lineClass: lineClass, titleClass: "project", label: label, pathColor: pathColor });
        });
        return (React.createElement("div", { id: "activity-component" },
            React.createElement("span", { className: "component-title" }, " Activiteiten "),
            this.props.isApproved ||
                React.createElement("div", null,
                    React.createElement(index_1.Margin, { margin: "12px" }),
                    React.createElement("span", { className: "button", onClick: function () { return _this.props.recalculateWorkDay(); } }, "Bijwerken")),
            this.props.canPreviewGpsProposal && this.props.gpsProposalUrl &&
                React.createElement("div", null,
                    React.createElement(index_1.Margin, { margin: "12px" }),
                    React.createElement("a", { className: "button", href: this.props.gpsProposalUrl, target: "_blank", rel: "noopener noreferrer" }, "GPS-voorstel")),
            _.isEmpty(activities) ? (React.createElement("div", null,
                React.createElement(index_1.Margin, { margin: "12px" }),
                React.createElement("p", null,
                    " ",
                    constants_1.NO_DATA_MESSAGE,
                    " "))) : (React.createElement("div", null,
                React.createElement(index_1.Margin, { margin: "12px" }),
                React.createElement(index_1.Row, null,
                    React.createElement(index_1.Column, null,
                        React.createElement("div", null, activities)))))));
    };
    return Activities;
}(React.Component));
exports.default = Activities;
